import apiClient from "./axios.server";

import getStaticData, { getLinks } from "./get_static_data.server";
import FetchPartnerData from "./get_partners.server";
import fetchInclusionData from "./get_inkusion_data.server";
import getchHomePageData from "./get_homepage_data.server";
import getTagsLIstSeach from "./get_tags";
import getAuthorsListSearch from "./get_authors";
import fetchThemenschwerpunkteListItem, {
  fetchThemenschwerpunkteById,
} from "./get_themenschwerpunkte_data.server";

export {
  apiClient,
  getLinks,
  getStaticData,
  FetchPartnerData,
  fetchInclusionData,
  fetchThemenschwerpunkteListItem,
  fetchThemenschwerpunkteById,
  getchHomePageData,
  getTagsLIstSeach,
  getAuthorsListSearch,
};
export {
  getFilterData,
  getWeiterFilterData,
  getTags,
  getAuthers,
} from "./get_filter_data.server";

export {
  fetchTeachingMethodsData,
  fetchTeachingMethodsById,
} from "./get_teachingMethods_data.server";
export { createBookmarktList, getFavoritArticles } from "./bookmarkt_list";
export { formSubmit } from "./contact_form";
